export default function( degrees ) {
	const cardinalDegrees = [
		[ "N", 0, 22.5 ],
		[ "NE", 22.5, 67.5 ],
		[ "E", 67.5, 112.5 ],
		[ "SE", 112.5, 157.5 ],
		[ "S", 157.5, 202.5 ],
		[ "SW", 202.5, 247.5 ],
		[ "W", 247.5, 292.5 ],
		[ "NW", 292.5, 337.5 ],

		// 361 so that degree 360 is inclusive to the below logic
		[ "N", 337.5, 361 ]
	];

	degrees = parseFloat( degrees );

	if ( isNaN( degrees ) ) {
		return degrees;
	}

	const matchingDirection = cardinalDegrees.find( direction => degrees >= direction[1] && degrees < direction[2] );

	return matchingDirection ? matchingDirection[0] : degrees;
}
